import { FulfillmentOrderProcessingRouteService } from 'common/data';
import { BaseService } from 'core/services';

class FulfillmentOrderProcessingService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FulfillmentOrderProcessingRouteService());
	}

	createFulfillmentShipment = (id, sourceOfChange, updateAndCreatePrintJob) => {
		const url = this.routeService.createFulfillmentShipment(id, sourceOfChange, updateAndCreatePrintJob);
		return this.apiClient.get(url);
	};

	createFulfillmentShipmentBulk = (params, sourceOfChange, updateAndCreatePrintJob) => {
		const url = this.routeService.createFulfillmentShipmentBulk(sourceOfChange, updateAndCreatePrintJob);
		return this.apiClient.post(url, { fulfillmentOrderIds: params.fulfillmentOrderIds });
	};

	assignCarrierServiceAndWarehouse(data, sourceOfChange) {
		const url = this.routeService.assignCarrierServiceAndWarehouse(sourceOfChange);
		return this.apiClient.post(url, data);
	}

	assignCarrierServiceAndWarehouseBulk(data, sourceOfChange) {
		const url = this.routeService.assignCarrierServiceAndWarehouseBulk(sourceOfChange);
		return this.apiClient.post(url, data);
	}

	markAsShipped(markAsShippedParams, sourceOfChange) {
		const url = this.routeService.markAsShipped(sourceOfChange);
		return this.apiClient.post(url, markAsShippedParams);
	}

	markAsShippedLtl(markAsShippedParams, sourceOfChange) {
		const url = this.routeService.markAsShippedLtl(sourceOfChange);
		return this.apiClient.post(url, markAsShippedParams);
	}

	markAsShippedBulk(markAsShippedBulkParams, sourceOfChange) {
		const url = this.routeService.markAsShippedBulk(sourceOfChange);
		return this.apiClient.post(url, markAsShippedBulkParams);
	}

	changeShipping(changeShippingParams, sourceOfChange) {
		const url = this.routeService.changeShipping(sourceOfChange);
		return this.apiClient.post(url, changeShippingParams);
	}

	changeShippingBulk(changeShippingBulkParams, sourceOfChange) {
		const url = this.routeService.changeShippingBulk(sourceOfChange);
		return this.apiClient.post(url, changeShippingBulkParams);
	}

	neverShipped(neverShippedParams, sourceOfChange) {
		var url = this.routeService.neverShipped(sourceOfChange);
		return this.apiClient.post(url, neverShippedParams);
	}

	neverShippedBulk(neverShippedBulkParams, sourceOfChange) {
		var url = this.routeService.neverShippedBulk(sourceOfChange);
		return this.apiClient.post(url, neverShippedBulkParams);
	}

	// this and onwards
	abortLabelingMode(abortLabelingParams, sourceOfChange) {
		const url = this.routeService.abortLabelingMode(sourceOfChange);
		return this.apiClient.post(url, abortLabelingParams);
	}

	splitFulfillmentOrderLabelingMode(splitFulfillmentOrderParams, sourceOfChange) {
		const url = this.routeService.splitFulfillmentOrderLabelingMode(sourceOfChange);
		return this.apiClient.post(url, splitFulfillmentOrderParams);
	}

	splitFulfillmentOrder = (fulfillmentOrders, sourceOfChange) => {
		const url = this.routeService.splitFulfillmentOrder(sourceOfChange);
		return this.apiClient.post(url, fulfillmentOrders);
	};

	editFulfillmentOrderSplit = (fulfillmentOrders, sourceOfChange) => {
		const url = this.routeService.editFulfillmentOrderSplit(sourceOfChange);
		return this.apiClient.post(url, fulfillmentOrders);
	};

	updateFulfillmentOrderInfo(order, sourceOfChange) {
		var url = this.routeService.updateFulfillmentOrderInfo(sourceOfChange);
		return this.apiClient.put(url, order);
	}

	assignCarrierAccount(order, sourceOfChange) {
		var url = this.routeService.assignCarrierAccount(sourceOfChange);
		return this.apiClient.put(url, order);
	}

	uploadLabel = (id, data) => {
		const url = this.routeService.uploadLabel(id);
		return this.apiClient.post(url, data);
	};

	getProNumber = id => {
		const url = this.routeService.getProNumber(id);
		return this.apiClient.post(url);
	};
}

export default FulfillmentOrderProcessingService;
